import Api from './api';

export default class ApiAnalytics extends Api {
    public static postAnalyticsEvent(category: string, action: string, label?: string, note?: string): Promise<void> {
        const data = {
            category: category,
            action: action,
            label: label,
            note: note,
        };
        return this.axios.post('/v1/analytics/generic', data);
    }
}
